// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { ThemeManager } from "../../../Controls/misc/ThemeManager.js";
import { DataCacheToolToolType } from "../DataCacheToolEnums.js";
import { DataCacheTool } from "../DataCacheTool.js";
import { DynProperty } from "../../DynProperty.js";

export let SymbolDataCacheTool = function ()
{
    this.symbolNum = -1;
    this.symbolBmp = null;

    DataCacheTool.apply(this);

    this.ToolType = DataCacheToolToolType.Symbol;
    this.InitPoints(1);
    this.InitBlock();
};

SymbolDataCacheTool.prototype = Object.create(DataCacheTool.prototype);

Object.defineProperty(SymbolDataCacheTool.prototype, 'SymbolNum', {
    get: function () { return this.symbolNum; },
    set: function (value)
    {
        if (this.symbolNum === value) return;

        this.symbolNum = value;
        var key = 'symbol' + (this.symbolNum + 1) + 'Img';
        this.symbolBmp = ThemeManager.CurrentTheme[key];
    }
});

Object.defineProperty(SymbolDataCacheTool.prototype, 'SymbolBmp', {
    get: function () { return this.symbolBmp; },
});

SymbolDataCacheTool.prototype.InitBlock = function ()
{
    DataCacheTool.prototype.InitBlock.apply(this);
    this.Width = 4;
    this.SymbolNum = 0;
}

SymbolDataCacheTool.prototype.MaxPointsCount = function () { return 1; };
SymbolDataCacheTool.prototype.MinPointsCount = function () { return 1; };

//#region ICaller

SymbolDataCacheTool.prototype.Properties = function ()
{
    var oldPros = DataCacheTool.prototype.Properties.apply(this);
    var props = [];
    props.push(new DynProperty("Symbol", this.symbolNum, DynProperty.SYMBOL, DynProperty.VISUAL_GROUP));

    var len = oldPros.length;
    for (var i = 0; i < len; i++)
    {
        var prop = oldPros[i];
        if (prop.group === DynProperty.NUMERICAL_PARAMETRS_GROUP || prop.group === DynProperty.HIDDEN_GROUP ||
            prop.name === "Stick to period" || prop.name === "IsBackground")
            props.push(prop);
    }

    return props;
};

SymbolDataCacheTool.prototype.callBack = function (properties)
{
    DataCacheTool.prototype.callBack.call(this, properties);

    var prop = DynProperty.getPropertyByName(properties, "Symbol");
    if (prop) this.SymbolNum = prop.value;
};

//#endregion